/** @format */
import { css } from 'styled-components';

import { RequestPasswordResetProps } from './index';

/**
 * Base styles for the request password reset component
 *
 * @param {RequestPasswordResetProps} props The request password reset properties object
 * */
// eslint-disable-next-line @typescript-eslint/no-unused-vars -- Legacy code: do not use as an example.
const baseStyles = (props: RequestPasswordResetProps) => css``;

/**
 * The request password reset component styles
 *
 * @param {RequestPasswordResetProps} props The request password reset properties object
 * */
export const styles = (props: RequestPasswordResetProps) => css`
    ${baseStyles(props)}
`;
